import { render, staticRenderFns } from "./tableIcon.vue?vue&type=template&id=4460642d&scoped=true"
import script from "./tableIcon.vue?vue&type=script&lang=js"
export * from "./tableIcon.vue?vue&type=script&lang=js"
import style0 from "./tableIcon.vue?vue&type=style&index=0&id=4460642d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4460642d",
  null
  
)

export default component.exports